import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { ReadingCTA } from '../components/ReadingCTA';
import { NewsletterBand } from '../components/NewsletterBand';
import { JournalCard } from '../components/JournalCard';
import { NeedFromAbby } from '../components/NeedFromAbby';
import { Button } from '../components/Button';
import { usePageMeta } from '../hooks/usePageMeta';
import { articles } from '../data/journal';
export function Article() {
  const {
    slug
  } = useParams();
  const article = articles.find(a => a.slug === slug);
  usePageMeta(article ? article.title : 'Article not found', article ? article.excerpt : 'This article could not be found.', article?.image);
  if (!article) {
    return <section className="gutter section text-center" data-id="element-572" data-mp="1hkvlhdhk9yp5">
        <h1 className="t-h2" data-id="element-573" data-mp="1hlnhuqizg0gh">This article isn't here.</h1>
        <Button to="/journal" className="mt-8" data-id="element-574" data-mp="1cuf7ns9twb29">
          Back to the Journal
        </Button>
      </section>;
  }
  const related = articles.filter(a => a.slug !== article.slug).slice(0, 3);
  const cta = article.category === 'Relationships' ? {
    title: 'See how your charts speak to each other',
    to: '/readings?type=synastry#book',
    proof: 1
  } : article.category === 'Timing & Transits' ? {
    title: 'Know what the months ahead hold',
    to: '/readings?type=transits#book',
    proof: 2
  } : {
    title: 'Read your whole chart with Abby',
    to: '/readings?type=birth-chart#book',
    proof: 0
  };
  return <>
      <article data-id="element-575" data-mp="132m66tqjv93k">
        <header className="gutter pb-10 pt-[clamp(2.5rem,6vw,6rem)]" data-id="element-576" data-mp="1334c6i30l1oo">
          <Link to="/journal" className="t-label inline-flex items-center gap-2 text-[0.64rem] text-graphite hover:text-charcoal" data-id="element-577" data-mp="p33ax1iu7s8o">
            <ArrowLeftIcon aria-hidden="true" strokeWidth={1.25} className="h-3.5 w-3.5" data-id="element-578" data-mp="t3wzzy80nd35" /> The Journal
          </Link>
          <p className="t-label mt-10 text-[0.66rem] text-gold-deep" data-id="element-579" data-mp="2je8ds3m3o0my">{article.category}</p>
          <h1 className="t-display mt-5 max-w-[20ch] !text-[clamp(2.4rem,1.4rem+3.4vw,6rem)]" data-id="element-580" data-mp="2nfk1g3leybsi">{article.title}</h1>
          <div className="mt-6 flex flex-wrap items-center gap-4 text-sm text-graphite" data-id="element-581" data-mp="3rfi5coau76gi">
            <span data-id="element-582" data-mp="3rhutjj76ud20">By Abby</span>
            <span aria-hidden="true" data-id="element-583" data-mp="3ndethyk99zup">·</span>
            <span data-id="element-584" data-mp="3ne6lkzen9fg8">{article.readTime}</span>
            <NeedFromAbby data-id="element-585" data-mp="3if3jnntynpch">final article copy</NeedFromAbby>
          </div>
        </header>
        <div className="gutter" data-id="element-586" data-mp="izovutexav8y">
          <img src={article.image} alt={article.imageAlt} className="aspect-[21/9] w-full bg-stone object-cover" data-id="element-587" data-mp="iyncm1nr72g5" />
        </div>
        <div className="gutter py-[clamp(3rem,6vw,7rem)]" data-id="element-588" data-mp="eywo64lp8yes">
          <div className="mx-auto max-w-[70ch] space-y-6 text-[clamp(1.05rem,0.98rem+0.3vw,1.3rem)] leading-[1.8] text-graphite" data-id="element-589" data-mp="a6lbs29rvk5c">
            <p className="t-lead !text-[clamp(1.25rem,1.05rem+0.6vw,1.75rem)] text-charcoal" data-id="element-590" data-mp="57s8f2o799iw">{article.excerpt}</p>
            {article.body.map(p => <p key={p.slice(0, 24)} data-id="element-591" data-mp="xwfpsn5tver6">{p}</p>)}
          </div>
        </div>
      </article>

      <section className="gutter pb-[clamp(4rem,8vw,9rem)]" aria-label="Book a reading" data-id="element-592" data-mp="158naasyn7i3k">
        <ReadingCTA title={cta.title} to={cta.to} proofIndex={cta.proof} data-id="element-593" data-mp="1a6ykj4sunumb" />
      </section>

      <NewsletterBand source="article_letter" data-id="element-594" data-mp="1f6bbo1qr7nup" />

      <section aria-labelledby="more-title" className="gutter section" data-id="element-595" data-mp="1f5i6h57g16eo">
        <h2 id="more-title" className="t-label text-charcoal" data-id="element-596" data-mp="1j8563sacvvmf">
          More from the Journal
        </h2>
        <ul className="mt-10 grid gap-x-[clamp(1rem,2vw,3rem)] gap-y-12 md:grid-cols-3" data-id="element-597" data-mp="1o5ybwk7qynm6">
          {related.map(a => <li key={a.slug} data-id="element-598" data-mp="1t4hz0ny2u5g4">
              <JournalCard article={a} data-id="element-599" data-mp="1t3q5dio1ihsh" />
            </li>)}
        </ul>
      </section>
    </>;
}